import { CommonDT, DateFilter, PageParams, ResultType, Sorter } from "../../CommonDT";
import { _delete, _get, _post, _put, _req } from "../../request";

export type VideoListDataType = CommonDT & {
  listType: string;
  fkUserUuid: string;
};

export type VideoListBatchDataType = {
  videoLists: VideoListDataType[];
};

export type VideoListPageDataType = {
  pageParams: PageParams;
  filter?: VideoListDataType;
  dateFilter?: DateFilter;
  sorter?: Sorter;
};

const get = async (id: string): Promise<ResultType> => {
  return await _get("/usr/videoList/", id);
};

const getVideoListId = async (userId: string): Promise<ResultType> => {
  return await _get("/usr/videoList/getVideoListId/", userId);
};

const list = async (data?: VideoListDataType): Promise<ResultType> => {
  return await _post("/usr/videoList/list", data);
};

const page = async (data?: VideoListPageDataType): Promise<ResultType> => {
  return await _post("/usr/videoList/page", data);
};

const listWithType = async (listId: string, postSourceTypeList: string[]): Promise<ResultType> => {
  return await _req("/usr/videoList/listWithType/", "GET", { listId, postSourceTypeList });
};

const batchSave = async (data: VideoListBatchDataType): Promise<ResultType> => {
  return await _post("/usr/videoList/batchSave", data);
};

const batchUpdate = async (data: VideoListBatchDataType): Promise<ResultType> => {
  return await _put("/usr/videoList/batchUpdate", data);
};

const alterStatus = async (videoListId: string, status: number): Promise<ResultType> => {
  return await _req("/usr/videoList/alterStatus", "PUT", {
    videoListId,
    status,
  });
};

const batchRemove = async (ids: string[]): Promise<ResultType> => {
  return await _delete("/usr/videoList/batchRemove", ids);
};

const batchRemoveVideo = async (listId: string, videoIds: string[]): Promise<ResultType> => {
  return await _req(
    "/usr/videoList/batchRemoveVideo",
    "delete",
    {},
    {
      listId,
      videoIds,
    }
  );
};

const clear = async (listId: string): Promise<ResultType> => {
  return await _req("/usr/videoList/clear", "delete", { listId });
};

const VideoListApi = {
  get,
  getVideoListId,
  list,
  listWithType,
  page,
  batchSave,
  batchUpdate,
  alterStatus,
  batchRemove,
  batchRemoveVideo,
  clear,
};

export default VideoListApi;
